import React, { useState } from 'react';
import { authApi } from '../services/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await authApi.login(email, password);
      localStorage.setItem('admin_token', res.data.token);
      onLogin(res.data.admin);
    } catch {
      setError('Email o password non corretti');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoBlock}>
          <div style={styles.logoIcon}>🏃</div>
          <div style={styles.logoText}>FRIULION</div>
          <div style={styles.logoSub}>ATHLETICS</div>
        </div>

        <h2 style={styles.title}>Accesso al pannello</h2>
        <p style={styles.subtitle}>Inserisci le tue credenziali per continuare</p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Email
            <input
              style={styles.input}
              type="email"
              placeholder="nome@esempio.it"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <label style={styles.label}>Password
            <input
              style={styles.input}
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          {error && <div style={styles.error}>⚠️ {error}</div>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Accesso in corso...' : 'Accedi →'}
          </button>
        </form>

        <p style={styles.footer}>Friulion Athletics · Pannello di amministrazione</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #0D3B6E 0%, #1a5276 100%)',
  },
  card: {
    background: '#fff', padding: '40px 36px', borderRadius: 20,
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)', width: 380, maxWidth: '90vw',
  },
  logoBlock: { textAlign: 'center', marginBottom: 24 },
  logoIcon:  { fontSize: 40, marginBottom: 6 },
  logoText:  { fontSize: 22, fontWeight: 900, color: '#0D3B6E', letterSpacing: 4 },
  logoSub:   { fontSize: 11, fontWeight: 700, color: '#F26522', letterSpacing: 5, marginTop: 2 },
  title:     { margin: '0 0 6px', fontSize: 20, fontWeight: 700, color: '#0D3B6E', textAlign: 'center' },
  subtitle:  { textAlign: 'center', color: '#888', fontSize: 13, marginBottom: 24 },
  label:     { display: 'block', fontSize: 13, fontWeight: 600, color: '#444', marginBottom: 14 },
  input: {
    display: 'block', width: '100%', padding: '12px 14px',
    marginTop: 5, borderRadius: 10, border: '1.5px solid #ddd',
    fontSize: 14, boxSizing: 'border-box', outline: 'none',
    transition: 'border-color 0.2s',
  },
  btn: {
    width: '100%', padding: '14px', marginTop: 8,
    background: '#F26522', color: '#fff', border: 'none',
    borderRadius: 10, fontSize: 15, fontWeight: 700,
    cursor: 'pointer', letterSpacing: 0.5,
  },
  error: {
    background: '#fff5f5', border: '1px solid #fcc', borderRadius: 8,
    padding: '10px 12px', color: '#c0392b', fontSize: 13, marginBottom: 12,
  },
  footer: { textAlign: 'center', color: '#ccc', fontSize: 11, marginTop: 24, marginBottom: 0 },
};
